import { GamepadManager } from "./Gamepads/GamepadManager.js";
import { ObjectCollection } from "object-collection-schema";
import { DivineControlEventManager } from "./Events/DivineControlsEventManager.js";
export const DivineControls = {
    controls: new ObjectCollection(),
    heldKeys: new Map(),
    _mouseInputs: {
        down: new Map(),
        hold: new Map(),
        up: new Map(),
    },
    _scrollInputs: {
        down: false,
        up: false,
    },
    _keyboardInputs: {
        down: new Map(),
        hold: new Map(),
        up: new Map(),
    },
    _gamePadInputs: {
        down: new Map(),
        hold: new Map(),
        up: new Map(),
    },
    _gamePadStickInputs: new Map(),
    _mapMoueButton(input) {
        if (input == 0)
            return "primary";
        if (input == 2)
            return "secondary";
        return "middle";
    },
    _mapKey(key) {
        return key.length == 1 ? key.toLocaleLowerCase() : key;
    },
    _capturing: false,
    _capturedData: {},
    $INIT() {
        window.addEventListener("gamepadconnected", (e) => {
            GamepadManager.addGamepad(e);
        });
        window.addEventListener("gamepaddisconnected", (e) => {
            GamepadManager.removeGamepad(e);
        });
        window.addEventListener("mousedown", (event) => {
            if (this._capturing) {
                this._capturedData = {
                    mouse: {
                        mode: "down",
                        button: this._mapMoueButton(event.button),
                    },
                };
                this._capturing = false;
                return;
            }
            const control = this._mouseInputs["down"].get(this._mapMoueButton(event.button));
            if (!control)
                return;
            const dcEvent = DivineControlEventManager.getEvent("mouse-down");
            control.action(dcEvent.setData(control));
        });
        window.addEventListener("mouseup", (event) => {
            const control = this._mouseInputs["up"].get(this._mapMoueButton(event.button));
            if (!control)
                return;
            const dcEvent = DivineControlEventManager.getEvent("mouse-up");
            control.action(dcEvent.setData(control));
        });
        window.addEventListener("keydown", (event) => {
            const key = this._mapKey(event.key);
            if (this._capturing) {
                this._capturedData = {
                    keyboard: {
                        key: key,
                        mode: "down",
                    },
                };
                this._capturing = false;
                return;
            }
            const control = this._keyboardInputs["down"].get(key);
            this.heldKeys.set(key, control ? control : false);
            if (!control)
                return;
            const dcEvent = DivineControlEventManager.getEvent("keyboard-down");
            control.action(dcEvent.setData(control));
        });
        window.addEventListener("keyup", (event) => {
            const key = this._mapKey(event.key);
            if (this.heldKeys.get(key)) {
                const control = this.heldKeys.get(key);
                if (control && control?.onDone) {
                    control.onDone();
                }
                this.heldKeys.delete(key);
            }
            const control = this._keyboardInputs["up"].get(key);
            if (!control)
                return;
            const dcEvent = DivineControlEventManager.getEvent("keyboard-up");
            control.action(dcEvent.setData(control));
        });
        window.addEventListener("wheel", (event) => {
            if (event.deltaY < 0) {
                if (this._capturing) {
                    this._capturedData = {
                        scroll: {
                            mode: "up",
                        },
                    };
                    this._capturing = false;
                    return;
                }
                const control = this._scrollInputs["up"];
                if (!control)
                    return;
                const dcEvent = DivineControlEventManager.getEvent("wheel-up");
                control.action(dcEvent.setData(control));
            }
            else {
                if (this._capturing) {
                    this._capturedData = {
                        scroll: {
                            mode: "down",
                        },
                    };
                    this._capturing = false;
                    return;
                }
                const control = this._scrollInputs["down"];
                if (!control)
                    return;
                const dcEvent = DivineControlEventManager.getEvent("wheel-down");
                control.action(dcEvent.setData(control));
            }
        });
    },
    registerControlGroups(data) {
        this.controls.addGroups(data);
    },
    _addControlInput(control) {
        for (const type in control.input) {
            if (type == "keyboard") {
                const inputMap = this._keyboardInputs[control.input[type].mode];
                inputMap.set(control.input[type].key, control);
            }
            if (type == "mouse") {
                const inputMap = this._mouseInputs[control.input[type].mode];
                inputMap.set(control.input[type].button, control);
            }
            if (type == "scroll") {
                this._scrollInputs[control.input[type].mode] = control;
            }
            if (type == "gamepad-button") {
                const inputMap = this._gamePadInputs[control.input[type].mode];
                inputMap.set(control.input[type].button, control);
            }
            if (type == "gamepad-axes") {
                this._gamePadStickInputs.set(control.input[type].stick, control);
            }
        }
    },
    _removeontrolInput(control) {
        for (const type in control.input) {
            if (type == "keyboard") {
                const inputMap = this._keyboardInputs[control.input[type].mode];
                inputMap.delete(control.input[type].key);
            }
            if (type == "mouse") {
                const inputMap = this._mouseInputs[control.input[type].mode];
                inputMap.delete(control.input[type].button);
            }
            if (type == "scroll") {
                this._scrollInputs[control.input[type].mode] = false;
            }
            if (type == "gamepad-button") {
                const inputMap = this._gamePadInputs[control.input[type].mode];
                inputMap.delete(control.input[type].button);
            }
            if (type == "gamepad-axes") {
                this._gamePadStickInputs.delete(control.input[type].stick);
            }
        }
    },
    registerControls(data) {
        this.controls.addNodes(data);
        for (const control of data) {
            this._addControlInput(control);
        }
    },
    getControl(id) {
        return this.controls.getData(id);
    },
    captureControlForInput(controlId) {
        console.log(this.controls._nodes, this._keyboardInputs);
        return new Promise((resolve) => {
            setTimeout(() => {
                this._capturing = true;
                const inte = setInterval(() => {
                    if (!this._capturing) {
                        resolve(true);
                        clearInterval(inte);
                        this.updateControlInputData(controlId, "keyboard", this._capturedData);
                    }
                }, 100);
            }, 200);
        });
    },
    updateControlInputData(controlId, type, data) {
        const control = this.getControl(controlId);
        if (!control) {
            throw new Error(`Control with id: ${controlId} does not exists`);
        }
        this._removeontrolInput(control);
        for (const type in control.input) {
            //@ts-ignore
            if (!data[type])
                continue;
            //@ts-ignore
            control.input[type] = structuredClone(data[type]);
        }
        this._addControlInput(control);
    },
    seralizeInputData() {
        return this.controls.store();
    },
    injestInputData(data) {
        this.controls.loadIn(data);
    },
    update() {
        GamepadManager.updateGamepads();
    },
};
